<template>
  <div class="myvaluation-container">
    <div v-if="loadingdata" class="brains-map-loader dataSidebarLoader" />
    <div class="valuation-content-container">
      <div class="valuation-text-container">
        <div class="valuation-text-container--title mb-1">{{ $t('asset-valuation-tool') }}</div>
        <!--
        <div class="valuation-text-container--text">
          {{ $t('asset-val-tool-init-text') }}
        </div>
        -->
        <button class="brains-type1-btn" style="margin-right:10px" @click="EditValuation()">{{ $t("asset-value") }}</button>
        <popoverBtn v-if="currentComparables.length > 0" class="container-popover-save" :button="false" activator="click" :border="true" position="bottom-center">
          <template
            v-slot:popoverName
          ><button id="brains_save_search_btn" :class="btnType">{{ $t("valuationFilters.export-val") }}</button></template>
          <div class="container-popover-selector container-popover-save-search row">
            <div class="col-12 row">
              <div v-for="(option, index) in exportValuationsOptions" :key="index" class="col-12">
                <div>
                  <checkBox v-model="option.checked" direction="left" :disabled="checkExportOption(option)" :input-value="option.id" :label="$t(option.literal)" />
                </div>
              </div>
            </div>
            <div class="col-12 d-flex--justify-content--end">
              <div>
                <button class="brains-type1-btn" @click="exportValuation()">{{ $t("export") }}</button>
              </div>
            </div>
          </div>
        </popoverBtn>
      </div>
      <el-dialog v-if="savevaluationpop" :visible.sync="savevaluationpop" class="savevaluationdialog" width="100%" center>
        <div class="brains-asset-data-container">
          <div class="brains-asset-data-container--col">
            <div class="brains-asset-data-left--images">
              <div class="images--street-view">
                <div class="valuations-images-container">
                  <div v-if="svVisible">
                    <div v-if="positionerror" class="msgnotfound">
                      {{ $t('streeview-not-image') }}
                    </div>
                    <div v-if="!positionerror" class="street-view-valuations-image street-view-valuations-image--1">
                      <div :id="googleStreeViewId(1)" ref="streetView1" class="googleStreeViewContainer" />
                    </div>
                  </div>
                  <div v-else class="position-not-selected">
                    {{ $t('position-not-selected') }}
                  </div>
                </div>
              </div>
              <div class="images--save-orientation">
                <div class="d-flex mr-1">
                  <label for="assetImages" class="brains-type5-btn">{{ $t('load-images') }}</label>
                  <input id="assetImages" ref="assetImages" multiple type="file" hidden name="assetImages" @change="uploadedImages">
                </div>
                <button class="brains-type1-btn" @click="saveOrientation()">{{ $t('save-sv-orientation') }}</button>
              </div>
              <div class="images--other-images mt-1">
                <div v-for="(image, index) in assetImages" :key="index" class="other-images--image">
                  <img :src="image" crossorigin="anonymous" alt="Asset Image">
                  <div class="other-images--remove-image" @click="removeImage(image, index)"><font-awesome-icon icon="times" /></div>
                </div>
                <div v-if="assetImages.length === 0" class="other-images--not-loaded">{{ $t('no-image-uploaded') }}</div>
              </div>
            </div>
          </div>
          <div class="brains-asset-data-container--col">
            <div class="brains-asset-data-right--title" style="width:80%">
              <el-input v-model="valuationname" size="mini" type="text" class="infotxt pf-new-input" placeholder="enter valuation name" />
              <div v-if="loading" class="brains-map-loader dataSidebarLoader" />
              <button class="brains-type1-btn btnsavevaluation" @click="saveValuation()">{{ $t("save") }}</button>
            </div>
            <div id="description" class="description-container mt-1">
              <div class="description--title">{{ $t('description') }}</div>
              <description v-model="valuationSave.description" />
            </div>
            <div class="brains-asset-data-right--asset-details mb-2 mt-1">
              <div class="asset-details--features mt-1">
                <div class="myvaluation_features">
                  <el-select v-model="tiposelector" class="asset-type pt-1" placeholder="Select">
                    <el-option value="flat" :label="$t('valuationFilters.flat')" />
                    <el-option value="house" :label="$t('valuationFilters.house')" />
                    <el-option value="retail" :label="$t('dataSelectors.retail')" />
                    <el-option value="office" :label="$t('dataSelectors.office')" />
                    <el-option value="industrial" :label="$t('dataSelectors.industrial')" />
                    <el-option value="landplot" :label="$t('dataSelectors.land-plot')" />
                    <el-option value="hospitality" :label="$t('dataSelectors.hospitality')" />
                    <el-option value="parking" :label="$t('valuationFilters.parking')" />
                    <el-option value="storage" :label="$t('valuationFilters.storage')" />
                    <el-option value="other" :label="$t('dataSelectors.other')" />
                  </el-select>

                  <div class="asset-features asset-display-style">
                    <label class="input-label">{{ $t("valuationFilters.features") }}</label>
                    <div class="features_selector">
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('bed')">
                        <img class="valuationiconval" :src="getIconSrc('bed')" alt="img">
                        <sup v-if="bed !== ''">{{ bed }}</sup>
                      </a>
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('bath')">
                        <img class="valuationiconval" :src="getIconSrc('bath')" alt="img">
                        <sup v-if="bath !== ''">{{ bath }}</sup>
                      </a>
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('lift')">
                        <img class="valuationiconval" :src="getIconSrc('lift')" alt="img">
                      </a>
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('parking')">
                        <img class="valuationiconval" :src="getIconSrc('parking')" alt="img">
                        <sup v-if="parking !== ''">{{ parking }}</sup>
                      </a>
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('trastero')">
                        <img class="valuationiconval" :src="getIconSrc('trastero')" alt="img">
                        <sup v-if="trastero !== ''">{{ trastero }}</sup>
                      </a>
                      <a href="javascript:;" role="button" aria-pressed="true" @click="toggleFeatures('pool')">
                        <img class="valuationiconval" :src="getIconSrc('pool')" alt="img">
                      </a>
                    </div>
                  </div>
                  <div class="asset-floor asset-display-style">
                    <label class="input-label">{{ $t("marketplace.floor") }}</label>
                    <numberInput v-model="floor" suffix="" placeholder="Min" class="" />
                  </div>
                  <div class="asset-const-year asset-display-style">
                    <label class="input-label">{{ $t("valuationFilters.const-year") }}</label>
                    <numberInput v-model="builtyear" suffix="" placeholder="Min" class="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="hotcontainer mt-1" style="width:100%">
              <button class="brains-type1-btn mb-1" @click="addNewRow()">Inserire Riga</button>
              <hot-table ref="hotTableValuation" :language="lang" :settings="tablesettings">
                <hot-column title="" />
                <hot-column title="Asset_ID" data="asset_id" />
                <hot-column title="Unit_ID" data="unit_id" />
                <hot-column title="Provincia" data="provincia" />
                <hot-column title="Comune" data="comune" />
                <hot-column title="Foglio" data="foglio" />
                <hot-column title="Mappale" data="mappale" />
                <hot-column title="Subalterno" data="subalterno" />
                <hot-column title="Destinazione d'uso" data="destinazione" />
                <hot-column title="GFA" data="gfa" />
                <hot-column title="Coeficiente (%)" data="coeficiente" />
                <hot-column title="GLA" read-only="true" data="gla" />
              </hot-table>
              <div class="mt-1">
                <label>Somma GFA </label>
                <el-input v-model="sommaGFA" size="mini" type="number" class="infotxt pf-new-input ml-1 mr-1" style="width: 10%" readonly />
                <label>GLA tot / GFA tot</label>
                <el-input v-model="GLAGFAtot" size="mini" type="number" class="infotxt pf-new-input ml-1 mr-1" style="width: 10%" readonly />
                <label>Somma GLA </label>
                <el-input v-model="sommaGLA" size="mini" type="number" class="infotxt pf-new-input ml-1 mr-1" style="width: 10%" readonly />
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <div class="valuation-data-container mt-2">
        <div class="valuation-data-container--asset-surface">
          <div class="asset-surface--label input-label">{{ $t('asset-surface') }}:</div>
          <div class="asset-surface--input">
            <numberInput v-model="surface" :min-val="1" :suffix="$t('valuationFilters.sqm')" placeholder="Min" />
          </div>
        </div>
        <div class="valuation-data-container--asset-value ml-5">
          <div class="asset-value--label input-label">{{ $t('asset-value') }}:</div>
          <div class="asset-value--input">
            <numberInput v-model="esqm" :decimals="0" :suffix="$t('marketplace.eur-sqm')" placeholder="Min" />
            <numberInput v-model="salevalue" :decimals="0" suffix="€" placeholder="Min" />
          </div>
        </div>
        <div class="valuation-data-container--days-sell ml-1">
          <div class="days-sell--label input-label">{{ $t('days-to-sell') }}:</div>
          <div class="days-sell--input">
            <numberInput v-model="daysToSell" :suffix="$t('days')" placeholder="Min" />
          </div>
        </div>
      </div>
      <div class="slider-container mt-2 mb-1">

        <singleRangeSlider v-model="salevalue" :clear="true" :step="1" :min="0" :max="maxValTop" />
      </div>

      <div class="valuation-table-container mt-2">
        <div class="valuation-table-container--table">
          <table style="margin-bottom: 10px" aria-describedby="tabl1s">
            <thead>
              <tr>
                <th class="brains-strong--600 pb-1">{{ $t('district') }}</th>
                <th class="brains-strong--600">{{ $t("marketplace.eur-sqm") }}</th>
                <th class="brains-strong--600">€</th>
                <th class="brains-strong--600">{{ $t('sqm') }}</th>
                <th class="brains-strong--600">{{ $t('days') }}</th>
              </tr>
            </thead>
            <tbody class="table-color-secondary">
              <tr>
                <td>{{ $t('asking-val') }}</td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].pub_esqm) }}</span>
                </td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].pub_eur) }}</span>
                </td>
                <td>{{ formatTableNum(price_summary[0].pub_sqm) }}</td>
                <td>{{ price_summary[0].pubdays }}</td>
              </tr>
              <tr>
                <td>{{ $t('closing-registery') }}</td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].unpub_esqm) }}</span>
                </td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].unpub_eur) }}</span>
                </td>
                <td>{{ formatTableNum(price_summary[0].unpub_sqm) }}</td>
                <td>{{ price_summary[0].unpubdays }}</td>
              </tr>
              <tr class="brains-table-tr-grey">
                <td>{{ $t('valuationFilters.discount') }}</td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].discount_esqm) }}%</span>
                </td>
                <td>
                  <span>{{ formatTableNum(price_summary[0].discount_eur) }}%</span>
                </td>
                <td />
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="valuation-table-container mt-5">
        <div class="valuation-table-container--table">
          <table style="margin-bottom: 10px" aria-describedby="tabl1r">
            <thead>
              <tr>
                <th class="brains-strong--600">{{ $t('comps-val') }}</th>
                <th class="brains-strong--600">{{ $t("marketplace.eur-sqm") }}</th>
                <th class="brains-strong--600">€</th>
                <th class="brains-strong--600">{{ $t('sqm') }}</th>
                <th class="brains-strong--600">{{ $t('days') }}</th>
              </tr>
            </thead>
            <tbody class="table-color-primary">
              <!-- First elements -->
              <tr class="table-tr-published">
                <td>{{ $t('valuationFilters.published') }}</td>
                <td>{{ formatTableNum(price_summary[1].pub_esqm) }}</td>
                <td>{{ formatTableNum(price_summary[1].pub_eur) }}</td>
                <td>{{ formatTableNum(price_summary[1].pub_sqm) }}</td>
                <td>{{ formatTableNum(price_summary[1].pubdays) }}</td>
              </tr>
              <tr class="table-tr-unpublished">
                <td>{{ $t('valuationFilters.unpublished') }}</td>
                <td>{{ formatTableNum(price_summary[1].unpub_esqm) }}</td>
                <td>{{ formatTableNum(price_summary[1].unpub_eur) }}</td>
                <td>{{ formatTableNum(price_summary[1].unpub_sqm) }}</td>
                <td>{{ formatTableNum(price_summary[1].unpubdays) }}</td>
              </tr>
              <tr class="brains-table-tr-grey">
                <td>{{ $t('valuationFilters.discount') }}</td>
                <td>{{ formatTableNum(price_summary[1].discount_esqm) }}%</td>
                <td>{{ formatTableNum(price_summary[1].discount_eur) }}%</td>
                <td />
                <td />
              </tr>
              <!-- Second elements -->
              <tr class="table-tr-sel-published">
                <td>{{ $t('selected-published') }}</td>
                <td>{{ formatTableNum(price_summary[2].pub_esqm) }}</td>
                <td>{{ formatTableNum(price_summary[2].pub_eur) }}</td>
                <td>{{ formatTableNum(price_summary[2].pub_sqm) }}</td>
                <td>{{ formatTableNum(price_summary[2].pubdays) }}</td>
              </tr>
              <tr class="table-tr-sel-unpublished">
                <td>{{ $t('selected-unpublished') }}</td>
                <td>{{ formatTableNum(price_summary[2].unpub_esqm) }}</td>
                <td>{{ formatTableNum(price_summary[2].unpub_eur) }}</td>
                <td>{{ formatTableNum(price_summary[2].unpub_sqm) }}</td>
                <td>{{ formatTableNum(price_summary[2].unpubdays) }}</td>
              </tr>
              <tr class="brains-table-tr-grey">
                <td>{{ $t('valuationFilters.discount') }}</td>
                <td>{{ formatTableNum(price_summary[2].discount_esqm) }}%</td>
                <td>{{ formatTableNum(price_summary[2].discount_eur) }}%</td>
                <td />
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <el-dialog v-if="visibleexport" :visible.sync="visibleexport" width="50%" center>
      <div class="container-export-valuation">
        <contentExportVal />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
// import loadingVeil from '@/components/designComponents/loadingVeil'
// import { getCardsData } from '@/api/comparable'
import numberInput from '@/components/designComponents/numberInput'
import { gmapApi } from 'gmap-vue'
import singleRangeSlider from '@/components/designComponents/singleRangeSlider'
import { mapState } from 'vuex'
import popoverBtn from '@/components/designComponents/popoverBtn'
import checkBox from '@/components/designComponents/checkBox'
import description from '@/components/designComponents/description'
import contentExportVal from '@/components/exportvaluation/contentExportVal'
import { generateHigchartOptions, generateStackTableOptions } from '@/utils/chartutils'
import 'handsontable/dist/handsontable.full.css'
import { HotTable, HotColumn } from '@handsontable/vue'
import Handsontable from 'handsontable'
import { registerAllModules } from 'handsontable/registry'
registerAllModules()
export default {
  name: 'MyValuation',
  components: { numberInput, singleRangeSlider, popoverBtn, checkBox, description, contentExportVal, HotTable, HotColumn },
  data: () => ({
    visibleexport: false,
    valuationname: '',
    svVisible: true,
    assetImages: [],
    positionerror: false,
    camaraDirection: 270,
    camaraDirection2: 90,
    savevaluationpop: false,
    priceSummLevel: '',
    isfirst: true,
    firstLoad: true,
    tiposelector: 'flat',
    bed: '3',
    bath: '2',
    lift: 1,
    parking: '',
    trastero: '',
    pool: '',
    floor: 1,
    builtyear: 1980,
    surface: 100,
    // Se separa salevalue y slidervalue para no entrar en bucle infinito
    salevalue: 0,
    default: {
      salevalue: 0,
      esqm: 0,
      surface: 0
    },
    esqm: 0,
    maxValTop: 100,
    discount_percent: '',
    loadingdata: false,
    loading: false,
    fromsavedval: false,
    price_summary: [
      {
        pub_esqm: '-',
        pub_eur: '-',
        pub_sqm: '-',
        unpub_esqm: '-',
        unpub_eur: '-',
        unput_sqm: '-',
        discount_esqm: '-',
        discount_eur: '-',
        pubdays: '-',
        unpubdays: '-'
      },
      {
        pub_esqm: '-',
        pub_eur: '-',
        pub_sqm: '-',
        unpub_esqm: '-',
        unpub_eur: '-',
        unput_sqm: '-',
        discount_esqm: '-',
        discount_eur: '-',
        pubdays: '-',
        unpubdays: '-'
      },
      {
        pub_esqm: '-',
        pub_eur: '-',
        pub_sqm: '-',
        unpub_esqm: '-',
        unpub_eur: '-',
        unput_sqm: '-',
        discount_esqm: '-',
        discount_eur: '-',
        pubdays: '-',
        unpubdays: '-'
      }
    ],

    // ------
    daysToSell: 48,
    sliderSel: 15,
    valuedSurface: 100,
    cad_ref: '',
    valuationSave: {
      description: '<span class="font-weight-600" style="font-size: 12px;">The asset  ....</span> <br /><p>The asset is located in...</p>',
      valuation: null,
      valuationFromBD: null,
      valuationSavedName: '',
      analysis_tab: '',
      comparables: {
        selected: [],
        deselected: []
      },
      streetViewOrientation: null
    },
    exportCharts: {
      marketevolution: null,
      newvs2hevolution: null,
      timetosaleevolution: null,
      builtstockyears: null
    },
    btnType: 'brains-type5-btn',
    exportValuationsOptions: [
      {
        id: 'resumen',
        literal: 'resume',
        checked: true
      },
      {
        id: 'comparables',
        literal: 'comps-val',
        checked: false
      },
      {
        id: 'imagenes',
        literal: 'images',
        checked: false
      },
      {
        id: 'data',
        literal: 'dataSelectors.data',
        checked: false
      },
      {
        id: 'poi',
        literal: 'poi-word',
        checked: false
      },
      {
        id: 'graficas',
        literal: 'chart',
        checked: false
      }
    ],
    tablesettings: {
      data: [],
      rowHeaders: false,
      readOnly: false,
      height: 'auto',
      afterOnCellMouseDown: function(e, coords, TD) {
        if (coords.col === 0) {
          this.alter('remove_row', coords.row)
        }
      },
      cells: function(row, col) {
        const cellPrp = {}
        if (col === 0) {
          cellPrp.readOnly = true
          cellPrp.renderer = function(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
          ) {
            Handsontable.renderers.TextRenderer.apply(this, arguments)
            td.innerHTML = '<button class="del brains-red-btn">Eliminare</button>'
          }
        }
        if (col === 11) {
          cellPrp.readOnly = true
          cellPrp.renderer = function(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
          ) {
            const percent = 100
            var gfa = parseInt(instance.getDataAtCell(row, 9))
            var coeficiente = parseInt(instance.getDataAtCell(row, 10))
            Handsontable.renderers.TextRenderer.apply(this, arguments)
            td.innerHTML = String(parseInt((gfa * coeficiente) / percent))
          }
        }
        return cellPrp
      },
      licenseKey: 'non-commercial-and-evaluation' // for non-commercial use only
    }
  }),
  computed: {
    ...mapState('valuations', {
      currentComparables: (state) => state.currentComparables,
      currentFilter: (state) => state.currentFilter,
      selectedcomparables: (state) => state.selectedcomparables,
      imageMapExport: (state) => state.imageMapExport,
      stockTableDataExport: (state) => state.stockTableDataExport
    }),
    ...mapState('location', {
      geolevels: (state) => state.geolevels,
      geolevelselected: (state) => state.geolevelselected,
      position: (state) => state.position,
      dataSidebarExport: (state) => state.dataSidebarExport
    }),
    ...mapState('pois', {
      pois: (state) => state.Pois
    }),
    saleValMin() {
      var res = Math.round(this.salevalue) / this.surface
      return res >= 1
    },
    lang: {
      get() {
        return localStorage.getItem('lang') + '-' + localStorage.getItem('lang').toUpperCase()
      }
    },
    google: gmapApi,
    sommaGFA() {
      var calc = 0
      this.tablesettings.data.forEach(element => {
        calc += parseInt(element.gfa)
      })
      return calc
    },
    GLAGFAtot() {
      var calc = 0
      calc = (this.sommaGFA / this.sommaGLA).toFixed(2)
      return calc
    },
    sommaGLA() {
      var calc = 0
      const percent = 100
      this.tablesettings.data.forEach(element => {
        calc += parseInt((element.gfa * element.coeficiente) / percent)
      })
      if (calc !== 0 && calc !== null) {
        this.setSurface(calc)
      }
      return calc
    }
  },
  watch: {
    currentComparables: function() {
      this.loadingdata = true
      this.initializeValuations()
    },
    surface: function() {
      if (this.fromsavedval) {
        return
      }
      if (this.surface === 0) {
        this.esqm = 1
        this.salevalue = 1
      }
      this.salevalue = this.esqm * this.surface

      if (this.surface !== null && this.surface !== undefined && this.surface !== '') {
        this.setMaxValTop()
      }
    },
    esqm(newOne) {
      if (this.fromsavedval) {
        return
      }
      if (newOne !== 0) {
        this.salevalue = Math.round(newOne * this.surface)
      }
    },
    salevalue(newOne, oldOne) {
      if (this.fromsavedval) {
        return
      }
      var esqmVal = Math.round(this.salevalue) / this.surface

      if (isNaN(esqmVal)) {
        this.esqm = 0
      }

      if (Math.round(esqmVal * this.surface) === newOne) {
        this.esqm = esqmVal
      }
    },
    selectedcomparables: function() {
      this.loadCompResume()
    },
    price_summary: {
      handler(newOne) {
        this.valuationSave.priceSummary = newOne
      },
      deep: true
    },
    'valuationSave.valuation.surface': {
      handler(newOne) {
        this.surface = newOne
      }
    }
  },
  created() {
    this.$root.$on('loadsavevaluation', (data) => {
      const vm = this
      vm.fromsavedval = true
      vm.loadfromsearch(data)
      setTimeout(() => { vm.fromsavedval = false }, 1000)
    })
  },
  updated() {
    if (!this.loadingdata && !this.firstLoad) {
      this.valuationSave.valuation = {
        tiposelector: this.tiposelector,
        bed: this.bed,
        bath: this.bath,
        lift: this.lift,
        parking: this.parking,
        trastero: this.trastero,
        pool: this.pool,
        floor: this.floor,
        builtyear: this.builtyear,
        surface: this.surface,
        esqm: this.esqm,
        salevalue: this.salevalue,
        daysToSell: this.daysToSell,
        maxValTop: this.maxValTop,
        valuedSurface: this.valuedSurface,
        cad_ref: this.cad_ref
      }
    }
  },
  methods: {
    setSurface(calc) {
      this.surface = calc
    },
    addNewRow() {
      const vm = this
      var newRow = {
        asset_id: '',
        unit_id: '',
        provincia: vm.$store.state.location.geolevels[2].name,
        comune: vm.$store.state.location.geolevels[3].name,
        foglio: '',
        mappale: '',
        subalterno: '',
        destinazione: '',
        gfa: 0,
        coeficiente: 0,
        gla: 0
      }
      vm.tablesettings.data.push(newRow)
      vm.$refs.hotTableValuation.hotInstance.updateSettings(vm.tablesettings)
    },
    EditValuation() {
      const vm = this
      debugger
      if (!vm.geolevelselected) {
        vm.$message({
          message: vm.$t('locationSelector.select-location-first'),
          type: 'error'
        })
        return
      }
      vm.loading = false
      vm.savevaluationpop = true
      if (vm.tablesettings.data.length === 0) {
        var setData = {
          asset_id: '',
          unit_id: '',
          provincia: vm.$store.state.location.geolevels[2].name,
          comune: vm.$store.state.location.geolevels[3].name,
          foglio: '',
          mappale: '',
          subalterno: '',
          destinazione: '',
          gfa: 0,
          coeficiente: 0,
          gla: 0
        }
        vm.tablesettings.data = [setData]
      }
      vm.svVisible = true
      vm.positionerror = false
      if (vm.position.latitude === null || vm.position.longitude === null) {
        vm.svVisible = false
        return
      }
      setTimeout(() => {
        var pos = { lat: this.position.latitude, lng: this.position.longitude }
        this.$gmapApiPromiseLazy().then(() => {
          const sv = new vm.google.maps.StreetViewService()
          this.panorama = new vm.google.maps.StreetViewPanorama(document.getElementById(vm.$refs.streetView1.id))
          sv.getPanorama(
            {
              location: pos,
              radius: 50,
              source: vm.google.maps.StreetViewSource.OUTDOOR
            },
            vm.processSVData
          )
        }).catch(err => {
          this.positionerror = true
          console.error(err)
          // debugger
        })
      }, 300)
    },
    processSVData(data, status) {
      if (status === 'OK') {
        var location = data.location
        this.panorama.setPano(location.pano)
        // debugger
        this.panorama.setPov({
          heading: this.camaraDirection,
          pitch: 0
        })
        this.panorama.setVisible(true)
      } else {
        this.positionerror = true
        console.error('Street View data not found for this location.')
      }
    },
    loadfromsearch(data) {
      const vm = this
      vm.valuationname = data.data.assetdata.name
      vm.valuationSave.description = data.data.assetdata.description
      vm.tiposelector = data.data.assetdata.tiposelector
      vm.bed = data.data.assetdata.bed
      vm.bath = data.data.assetdata.bath
      vm.lift = data.data.assetdata.lift
      vm.parking = data.data.assetdata.parking
      vm.trastero = data.data.assetdata.trastero
      vm.pool = data.data.assetdata.pool
      vm.floor = data.data.assetdata.floor
      vm.builtyear = data.data.assetdata.builtyear
      vm.esqm = data.data.assetdata.esqm
      vm.salevalue = data.data.assetdata.salevalue
      vm.surface = data.data.assetdata.surface
      vm.daysToSell = data.data.assetdata.daysToSell
      vm.maxValTop = data.data.assetdata.maxValTop
      vm.valuedSurface = data.data.assetdata.valuedSurface
      vm.valuationSave.priceSummary = data.priceSummary
      vm.assetImages = data.data.assetdata.images
      vm.tablesettings.data = data.data.assetdata.glatable.rows
      document.getElementById('autocomplete').value = data.address
    },
    saveValuation() {
      const vm = this
      vm.loading = true
      var handsontable = {
        sumgfa: vm.sommaGFA,
        avgglatotal: vm.GLAGFAtot,
        sumgla: vm.sommaGLA,
        rows: vm.tablesettings.data
      }
      /*
      vm.tablesettings.data.forEach(element => {
        handsontable.rows.push({
          assetid: element.asset_id,
          unitid: element.unitid,
          province: element.provincia,
          comune: element.comune,
          foglio: element.foglio,
          mappale: element.mappale,
          subalterno: element.subalterno,
          destinazione: element.destinazione,
          gfa: element.gfa,
          coeficiente: element.coeficiente,
          gla: element.gla
        })
      })
      */
      const savesearch = {
        assetdata: {
          name: vm.valuationname,
          description: vm.valuationSave.description,
          tiposelector: this.tiposelector,
          bed: this.bed,
          bath: this.bath,
          lift: this.lift,
          parking: this.parking,
          trastero: this.trastero,
          pool: this.pool,
          floor: this.floor,
          builtyear: this.builtyear,
          surface: this.surface,
          esqm: this.esqm,
          salevalue: this.salevalue,
          daysToSell: this.daysToSell,
          maxValTop: this.maxValTop,
          valuedSurface: this.valuedSurface,
          images: [],
          glatable: handsontable
        },
        priceSummary: vm.valuationSave.priceSummary,
        position: vm.position,
        currentComparables: vm.currentComparables,
        selectedcomparables: vm.selectedcomparables,
        currentFilter: vm.currentFilter
      }
      // imagenes
      document.getElementsByClassName('images--other-images')[0].getElementsByTagName('img').forEach((im, index) => {
        var canvas = document.createElement('canvas')
        // debugger
        canvas.width = im.naturalWidth
        canvas.height = im.naturalHeight
        var ctx = canvas.getContext('2d')
        ctx.drawImage(im, 0, 0, im.naturalWidth, im.naturalHeight)
        var dataURL = canvas.toDataURL('image/png')
        // dataURL = dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
        savesearch.assetdata.images.push(dataURL)
        canvas = null
      })
      // debugger
      // console.log(savesearch)
      const saveval = {
        ValuationName: vm.valuationname,
        Address: document.getElementById('autocomplete').value,
        Data: JSON.stringify(savesearch)
      }
      vm.loading = true
      vm.$store.dispatch('valuations/saveValuation', saveval).then(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('valuationsaved'),
          type: 'success'
        })
        vm.savevaluationpop = false
      }).catch((error) => {
        vm.loading = false
        console.error(error)
        vm.$message({
          message: vm.$t('userData.operation-error'),
          type: 'error'
        })
      })
    },
    uploadedImages() {
      var filesInit = [...this.$refs.assetImages.files]
      filesInit.forEach((file, i) => {
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          filesInit.splice(i, 1)
        } else {
          this.assetImages.push(URL.createObjectURL(file))
        }
      })
    },
    saveOrientation() {
      const vm = this
      if (!vm.svVisible) {
        vm.$message({
          message: this.$t('invalidstreetview'),
          type: 'error'
        })
        return
      }
      let url = 'https://maps.googleapis.com/maps/api/streetview?size=800x800&location=' + vm.panorama.position.lat() + ',' + vm.panorama.position.lng()
      url += '&heading=' + vm.panorama.pov.heading + '&pitch=' + vm.panorama.pov.pitch + '&zoom=' + vm.panorama.pov.zoom
      url += '&source=outdoor&key=' + window._env_.VUE_APP_GOOGLE_KEY
      vm.assetImages.push(url)
    },
    removeImage(img, id) {
      const vm = this
      vm.assetImages.splice(id, 1)
    },
    googleStreeViewId(id) {
      return 'googleStreetViewContainer-' + Math.floor(Date.now() * (9999 - 0)) + id
    },
    initializeValuations() {
      this.loadCardData()
    },
    loadValuationData() {
      if (this.currentComparables.length === 0) {
        return
      }

      const comparables = this.currentComparables
      const arithmetic_avg =
        _.reduce(_.pluck(comparables, 'c_precio'), function(memo, num) {
          return memo + num
        }) / comparables.length

      // if (this.valuationSave.valuation === null || this.valuationSave.valuation === undefined) {
      //   const surface_avg = _.reduce(_.pluck(comparables, 'c_superficie'), function(memo, num) { return memo + num }) / comparables.length
      //   this.surface = Math.round(surface_avg)
      // }

      if (this.price_summary[0].unpub_esqm && this.price_summary[0].unpub_esqm !== '-' && this.price_summary[0].unpub_eur && this.price_summary[0].unpub_eur !== '-') {
        if (!this.fromsavedval) {
          this.esqm = Math.round(this.price_summary[0].unpub_esqm)
          this.salevalue = Math.round(this.price_summary[0].unpub_esqm * this.surface)
        }
      } else {
        if (!this.fromsavedval) {
          // this.esqm = Math.round(arithmetic_avg / this.surface)
          // Se establece directamente el precio metro cuadrado de los selccionados
          this.esqm = Math.round(this.price_summary[2].pub_esqm)
          this.salevalue = Math.round(arithmetic_avg)
        }
      }

      this.firstLoad = false
      this.loadingdata = false
      this.default = {
        salevalue: this.salevalue,
        esqm: this.esqm,
        surface: this.surface
      }

      this.setMaxValTop()
    },
    setMaxValTop() {
      this.maxValTop = _.max(this.currentComparables, (comparable) => { return comparable.c_precio }).c_precio * 1.5
    },
    loadCardData() {
      if (this.geolevels.length === 0) return
      var vm = this

      var lv = 4
      this.priceSummLevel = this.$t('price-summ-im')
      var geolvl = _.filter(this.geolevels, function(item) {
        return item.level === lv
      })
      var idtipo = ''
      if (geolvl.length === 0) {
        return
      }
      if (this.currentFilter.flat.flat_type.length > 1 || this.currentFilter.flat.flat_type.length === 0) {
        idtipo = 'residential'
      } else if (
        this.currentFilter.flat.flat_type[0] === 'landplot' ||
        this.currentFilter.flat.flat_type[0] === 'hospitality' ||
        this.currentFilter.flat.flat_type[0] === 'other' ||
        this.currentFilter.flat.flat_type[0] === 'all'
      ) {
        idtipo = 'residential'
      } else {
        idtipo = this.currentFilter.flat.flat_type[0]
      }
      var filter = {
        geolevel: geolvl.length > 0 ? geolvl[0] : null,
        typologie: idtipo,
        contract: this.currentFilter.sale.c_tipo_contrato
      }
      vm.$store.dispatch('valuations/getCardsData', filter).then((response) => {
        if (response[1] !== null) {
          vm.price_summary[0].pub_esqm = response[1].esqm !== null ? response[1].esqm : '-'
          vm.price_summary[0].pub_eur = response[1].price !== null ? response[1].price : '-'
          vm.price_summary[0].pub_sqm = response[1].m2 !== null ? response[1].m2 : '-'
        } else {
          vm.price_summary[0].pub_esqm = '-'
          vm.price_summary[0].pub_eur = '-'
          vm.price_summary[0].pub_sqm = '-'
        }
        if (response[0] !== null) {
          vm.price_summary[0].unpub_esqm = response[0].esqm !== null ? response[0].esqm : '-'
          vm.price_summary[0].unpub_eur = response[0].price !== null ? response[0].price : '-'
          vm.price_summary[0].unpub_sqm = response[0].m2 !== null ? response[0].m2 : '-'
          if (response[0] !== null) {
            vm.price_summary[0].discount_esqm = ((response[0].esqm - response[1].esqm) / response[1].esqm) * 100
            vm.price_summary[0].discount_eur = ((response[0].price - response[1].price) / response[1].price) * 100
          } else {
            vm.price_summary[0].discount_esqm = '-'
            vm.price_summary[0].discount_eur = '-'
          }
        } else {
          vm.price_summary[0].unpub_esqm = '-'
          vm.price_summary[0].unpub_eur = '-'
          vm.price_summary[0].unpub_sqm = '-'
          vm.price_summary[0].discount_esqm = '-'
          vm.price_summary[0].discount_eur = '-'
        }

        vm.loadCompResume()
        vm.loadValuationData()
      })
    },
    loadCompResume() {
      var vm = this
      var published = _.filter(vm.currentComparables, function(item) {
        return item.c_categoria === 'Publicados'
      })
      var unpublished = _.filter(vm.currentComparables, function(item) {
        return item.c_categoria === 'No publicados'
      })

      if (published.length === 0) {
        vm.price_summary[1].pub_esqm = '-'
        vm.price_summary[1].pub_eur = '-'
        vm.price_summary[1].pub_sqm = '-'
      } else {
        vm.price_summary[1].pub_esqm =
          _.reduce(
            published,
            function(memo, item) {
              return memo + item.c_eurom2
            },
            0
          ) / published.length

        vm.price_summary[1].pub_eur =
          _.reduce(
            published,
            function(memo, item) {
              return memo + item.c_precio
            },
            0
          ) / published.length

        vm.price_summary[1].pub_sqm =
          _.reduce(
            published,
            function(memo, item) {
              return memo + item.c_superficie
            },
            0
          ) / published.length

        vm.price_summary[1].pubdays =
          _.reduce(
            published,
            function(memo, item) {
              return memo + item.pubdays
            },
            0
          ) / published.length
      }

      if (unpublished.length === 0) {
        vm.price_summary[1].unpub_esqm = '-'
        vm.price_summary[1].unpub_eur = '-'
        vm.price_summary[1].unput_sqm = '-'
      } else {
        vm.price_summary[1].unpub_esqm =
          _.reduce(
            unpublished,
            function(memo, item) {
              return memo + item.c_eurom2
            },
            0
          ) / unpublished.length

        vm.price_summary[1].unpub_eur =
          _.reduce(
            unpublished,
            function(memo, item) {
              return memo + item.c_precio
            },
            0
          ) / unpublished.length

        vm.price_summary[1].unpub_sqm =
          _.reduce(
            unpublished,
            function(memo, item) {
              return memo + item.c_superficie
            },
            0
          ) / unpublished.length

        vm.price_summary[1].unpubdays =
          _.reduce(
            unpublished,
            function(memo, item) {
              return memo + item.pubdays
            },
            0
          ) / unpublished.length
      }

      if (published.length === 0 || unpublished.length === 0) {
        vm.price_summary[1].discount_esqm = '-'
        vm.price_summary[1].discount_eur = '-'
      } else {
        // vm.price_summary[1].discount_esqm = (((vm.price_summary[1].pub_esqm / vm.price_summary[1].unpub_esqm) - 1) * 100)
        // vm.price_summary[1].discount_eur = (((vm.price_summary[1].pub_eur / vm.price_summary[1].unpub_eur) - 1) * 100)
        vm.price_summary[1].discount_esqm = ((vm.price_summary[1].unpub_esqm - vm.price_summary[1].pub_esqm) / vm.price_summary[1].pub_esqm) * 100
        vm.price_summary[1].discount_eur = ((vm.price_summary[1].unpub_eur - vm.price_summary[1].pub_eur) / vm.price_summary[1].pub_eur) * 100
      }

      var selected = vm.selectedcomparables
      var pub_selected = _.filter(selected, function(item) {
        return item.c_categoria === 'Publicados'
      })
      var unpub_selected = _.filter(selected, function(item) {
        return item.c_categoria === 'No publicados'
      })
      if (pub_selected.length === 0) {
        vm.price_summary[2].pub_esqm = '-'
        vm.price_summary[2].pub_eur = '-'
        vm.price_summary[2].pub_sqm = '-'
      } else {
        vm.price_summary[2].pub_esqm =
          _.reduce(
            pub_selected,
            function(memo, item) {
              return memo + item.c_eurom2
            },
            0
          ) / pub_selected.length

        vm.price_summary[2].pub_eur =
          _.reduce(
            pub_selected,
            function(memo, item) {
              return memo + item.c_precio
            },
            0
          ) / pub_selected.length

        vm.price_summary[2].pub_sqm =
          _.reduce(
            pub_selected,
            function(memo, item) {
              return memo + item.c_superficie
            },
            0
          ) / pub_selected.length

        vm.price_summary[2].pubdays =
          _.reduce(
            pub_selected,
            function(memo, item) {
              return memo + item.pubdays
            },
            0
          ) / pub_selected.length
      }
      if (unpub_selected.length === 0) {
        vm.price_summary[2].unpub_esqm = '-'
        vm.price_summary[2].unpub_eur = '-'
        vm.price_summary[2].unput_sqm = '-'
      } else {
        vm.price_summary[2].unpub_esqm =
          _.reduce(
            unpub_selected,
            function(memo, item) {
              return memo + item.c_eurom2
            },
            0
          ) / unpub_selected.length

        vm.price_summary[2].unpub_eur =
          _.reduce(
            unpub_selected,
            function(memo, item) {
              return memo + item.c_precio
            },
            0
          ) / unpub_selected.length

        vm.price_summary[2].unpub_sqm =
          _.reduce(
            unpub_selected,
            function(memo, item) {
              return memo + item.c_superficie
            },
            0
          ) / unpub_selected.length

        vm.price_summary[2].unpubdays =
          _.reduce(
            unpub_selected,
            function(memo, item) {
              return memo + item.pubdays
            },
            0
          ) / unpub_selected.length
      }
      if (pub_selected.length === 0 || unpub_selected.length === 0) {
        vm.price_summary[2].discount_esqm = '-'
        vm.price_summary[2].discount_eur = '-'
      } else {
        // vm.price_summary[2].discount_esqm = (((vm.price_summary[2].pub_esqm / vm.price_summary[2].unpub_esqm) - 1) * 100)
        // vm.price_summary[2].discount_eur = (((vm.price_summary[2].pub_eur / vm.price_summary[2].unpub_eur) - 1) * 100)
        vm.price_summary[2].discount_esqm = ((vm.price_summary[2].unpub_esqm - vm.price_summary[2].pub_esqm) / vm.price_summary[2].pub_esqm) * 100
        vm.price_summary[2].discount_eur = ((vm.price_summary[2].unpub_eur - vm.price_summary[2].pub_eur) / vm.price_summary[2].pub_eur) * 100
      }

      // vm.valuationDataToPrint.price_summary = vm.price_summary
    },
    getIconSrc(tipo) {
      switch (tipo) {
        case 'bed':
          return this.bed > 0 ? require('@/assets/brains_icons/bedon.png') : require('@/assets/brains_icons/bedoff.png')
        case 'bath':
          return this.bath > 0 ? require('@/assets/brains_icons/bathon.png') : require('@/assets/brains_icons/bathoff.png')
        case 'parking':
          return this.parking > 0 ? require('@/assets/brains_icons/parkingon.png') : require('@/assets/brains_icons/parkingoff.png')
        case 'trastero':
          return this.trastero > 0 ? require('@/assets/brains_icons/trasteroon.png') : require('@/assets/brains_icons/trasterooff.png')
        case 'lift':
          return this.lift > 0 ? require('@/assets/brains_icons/lifton.png') : require('@/assets/brains_icons/liftoff.png')
        case 'pool':
          return this.pool > 0 ? require('@/assets/brains_icons/poolon.png') : require('@/assets/brains_icons/pooloff.png')
      }
    },
    toggleFeatures(tipo) {
      switch (tipo) {
        case 'bed':
        case 'bath':
        case 'parking':
        case 'trastero':
          if (this[tipo] === 4) {
            this[tipo] = '+4'
          } else if (this[tipo] === '+4') {
            this[tipo] = ''
          } else {
            this[tipo]++
          }
          break
        case 'lift':
        case 'pool':
          if (this[tipo] === 1) {
            this[tipo]--
          } else {
            this[tipo]++
          }
          break
      }
    },
    formatDecimalValue(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatTableNum(num) {
      if (num !== undefined) {
        return num.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      } else {
        return num
      }
    },
    denyNaN: function(e) {
      e = e || window.event
      var charCode = e.which ? e.which : e.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault()
      } else {
        return true
      }
    },
    formatSaleValue: function(e) {
      if (this.salevalue !== null && this.salevalue !== undefined && this.salevalue !== '') {
        this.salevalue = this.formatDecimalValue(this.salevalue.replace(/\./g, ''))
      }
    },
    resetSaleValue() {
      var val = this.default.salevalue
      this.salevalue = this.formatDecimalValue(val)
      this.surface = this.default.surface
      this.esqm = this.default.esqm
    },
    checkExportOption(option) {
      switch (option.id) {
        case 'resumen':
        case 'comparables':
        case 'data':
        case 'poi':
        case 'graficas':
        case 'imagenes':
          return false
        // case 'imagenes':
        //   if (this.valuationSave.imagesUrl !== undefined && this.valuationSave.imagesUrl.length > 0) {
        //     return false
        //   } else {
        //     return true
        //   }
        case 'catastro':
          if (this.valuationSave.valuation !== null && this.valuationSave.valuation.cad_ref !== '') {
            return false
          } else {
            return true
          }
        default:
          return false
      }
    },
    exportValuation() {
      const vm = this
      if (vm.exportValuationsOptions.filter(item => { return item.id === 'graficas' && item.checked }).length > 0) {
        const objsearch = {
          actualSelection: ['dataSelectors.sale-market', 'dataSelectors.residential', 'chart_quarter_evol'],
          chart_name: 'Mercato di vendita - Residenziale - chart_quarter_evol',
          country_idcod: 57363,
          countryid: 57363,
          geolevel: vm.geolevelselected,
          latitude: vm.position.latitude,
          longitude: vm.position.longitude,
          municipality_idcod: 1238266,
          key: '',
          geolevelselected: vm.geolevelselected,
          typologyid: 0,
          geolevels: vm.geolevels,
          geolevelid: vm.geolevelselected.id,
          chartvisid: '0',
          typologie: '0',
          upper_idcod: 57477
        }
        if (vm.tiposelector === 'retail') {
          objsearch.typologie = 7
        } else if (vm.tiposelector === 'office') {
          objsearch.typologie = 8
        } else if (vm.tiposelector === 'industrial') {
          objsearch.typologie = 10
        }
        vm.searchExportCharts1Data(objsearch)
      }

      vm.loadingdata = true
      vm.$root.$emit('TakeScreenshotExport', vm.currentFilter.more_filters.search_radius)

      setTimeout(() => {
        var data_export_val = {
          exportValuationsOptions: vm.exportValuationsOptions,
          exportTitle: vm.locationtxt,
          comparables: {
            currentComparables: vm.currentComparables,
            selectedcomparables: vm.selectedcomparables
          },
          valuationSave: vm.valuationSave,
          dataSidebarExport: vm.dataSidebarExport, // .map(item => { return { feature: { attributes: item.attributes }} }),
          imageMapExport: vm.imageMapExport.dataUrl,
          stockTableDataExport: vm.stockTableDataExport,
          pois: vm.pois,
          exportCharts: vm.exportCharts,
          mapResumenPosition: { latitude: vm.position.latitude, longitude: vm.position.longitude, geolevels: vm.geolevels },
          googleGeocoder: vm.googleGeocoder
        }
        vm.loadingdata = false
        localStorage.setItem('data_export_val', JSON.stringify(data_export_val))
        vm.visibleexport = true
        // vm.$router.push({ name: 'export-valuations' })
        // window.open('/#/valuations/export-valuations', '_blank').focus()
      }, 2800)
    },
    searchExportCharts1Data(filter) {
      const vm = this
      vm.$store
        .dispatch('charts/setchartexport', filter).then((response) => {
          const countryname = vm.geolevels[0].name
          var sectioncharts = response.chartsdata.map(item => {
            return {
              name: item.charttitle,
              type: item.charttype,
              options: item.charttype !== 'stocktable' ? generateHigchartOptions(item, response.allseries, vm.geolevelselected.name, countryname, vm.geolevelselected) : generateStackTableOptions(item, response.allseries)
            }
          })
          vm.exportCharts.marketevolution = sectioncharts[0].options
          vm.exportCharts.newvs2hevolution = sectioncharts[1].options
          vm.exportCharts.timetosaleevolution = sectioncharts[2].options
          vm.exportCharts.builtstockyears = sectioncharts[3].options
        })
        .catch((error) => {
          console.log(error)
          // debugger
        })
    }
  }
}
</script>

<style lang="scss">
.savevaluationdialog .el-dialog {
  margin-top:10px !important;
}
.other-images--remove-image {
  position: absolute;
  right: 0;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.1s;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.671);
  color: white;
}
.valuations-images-container {
  height: 450px;
  display: contents;
  padding: 10px;

  .street-view-valuations-image {
    height: 50%;
    width: 100%;
    margin-bottom: 10px;
  }
}
.googleStreeViewContainer {
  height: 300px;
  width: 100%;
}
.input-label {
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: 600;
}

.container-export-valuation {
  width: 100%;
  height: 100%;
}

.valuation-content-container {
  .valuation-text-container {
    &--title {
      font-family: "Montserrat-SemiBold",sans-serif;
      font-size: 16px;
    }

    &--text {
      font-size: 13px;
      line-height: 1.5;
    }
  }

  .valuation-data-container {
    display: flex;
    justify-content: flex-start;

    &--asset-surface {
      width: 20%;

      .asset-surface--label {
        font-size: 13px;
        margin-bottom: 10px;
      }

      .asset-surface--input {
        width: 100%;
      }
    }

    &--asset-value {
      width: 40%;

      .asset-value--input {
        display: flex;
        justify-content: space-between;

        .inp_container {
          width: 49%;
        }
      }
    }
  }
}

.myvaluation-container {
  padding: 15px 10px 15px 10px;

  .tipo_selector .el-input__suffix {
    display: none;
  }

  .valuation_small_input {
    input {
      padding: 0 !important;
      height: 27px;
      text-align: center;
    }

    span {
      width: 15px;
      line-height: 13px !important;
    }
  }

  .valuation_input {
    height: 27px;
    line-height: 27px;

    input {
      border-radius: 0;
      height: 27px;
      border: 1px solid #1e3cff;
    }
  }
}
</style>
<style lang="scss" scoped>

.slider-container {
  width: 90%;
  text-align: center;
}

.valuation-saved-valuation-info {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 50% 50%;

  .col {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      color: #1e3cff;
      font-family: "Montserrat-SemiBold",sans-serif;
      margin-left: 5px;
    }
  }

  .col-right {
    display: flex;
    justify-content: flex-end;
  }
}
.myvaluation_features {
  display: flex;
  /*align-items: center;*/
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-end;

  .asset-type {
    width: 20%;
    margin-top: 12px;
    margin-bottom: -4px;
  }

  .asset-floor {
    width: 20%;
  }

  .asset-const-year {
    width: 20%;
  }
}

.features_selector {
  position: relative;
  display: block;
  border: 1px solid #1e3cff;
  padding: 4px;
  margin-bottom: -1px;

  a {
    position: relative;
    display: inline;
    padding: 0 7px;

    svg {
      vertical-align: middle;
    }

    sup {
      position: absolute;
      top: 6px;
    }
  }
}

.btnsavevaluation {
  width: 90px;
  margin-left: 10px;
}

.brains-asset-data-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-height: 95vh;
  &--col {
    width: 49.5%;
    height: 85vh;

    .brains-asset-data-right {
      &--title {
        align-items: center;
        display: flex;
        padding-left: 10px;
        padding-top: 10px;
        padding-bottom: 20px;
        padding-right: 30px;
        font-size: 16px;
        font-weight: 600;
        justify-content: space-between;
      }

      &--asset-details {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .asset-details--location {
          display: inline-block;
          width: 45%;
          margin-right: 15px;
        }

        .asset-details--valued-surf {
          display: inline-block;
        }
      }

      &--tabs-container {
        .brains-asset-data-right--tabs {
          max-height: 740px;
          overflow: scroll;
          overflow-x: hidden;
          padding-bottom: 50px;
        }
      }
    }

    .brains-asset-data-left {
      overflow: scroll;

      &--title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;

        h3 {
          font-weight: 600;
        }
      }

      &--images {
        .images--street-view {
          height: 300px;
        }

        .images--save-orientation {
          display: flex;
          justify-content: flex-end;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        .images--other-images {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          padding-left: 5px;
          gap: 5px;
          width: 100%;
          max-height: 50vh;
          overflow: scroll;

          .other-images--image {
            width: 49%;
            max-height: 300px;
            display: flex;
            overflow: hidden;
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .other-images--not-loaded {
            width: 100%;
            text-align: center;
            padding-top: 50px;
            padding-bottom: 30px;
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
